import Modal from "bootstrap/js/dist/modal"

class GlobalPopup {
  constructor() {
    // 🔁 Detekcija početka nove sesije
    if (!sessionStorage.getItem('popup_session_active')) {
      sessionStorage.setItem('popup_session_active', 'true')

      if (!localStorage.getItem('popup_session_started')) {
        localStorage.removeItem('one_click_marketing_exit_modal')
        localStorage.setItem('popup_session_started', 'true')
        console.log('[GlobalPopup] Nova sesija, brišem staro stanje')
      }
    }

    this.channel = new BroadcastChannel('popup_channel')
    console.log('[GlobalPopup] BroadcastChannel initialized')

    this.channel.onmessage = (event) => {
      console.log('[GlobalPopup] Primljena poruka:', event.data)

      if (event.data === 'popup_closed') {
        localStorage.setItem('one_click_marketing_exit_modal', 'closed')
        console.log('[GlobalPopup] Zapis u localStorage: zatvoreno')
      }

      if (event.data === 'popup_force_close') {
        const allModals = document.querySelectorAll('.modal.show')
        allModals.forEach(modal => {
          const modalInstance = Modal.getInstance(modal)
          if (modalInstance) {
            modalInstance.hide()
            console.log('[GlobalPopup] Zatvaram modal putem broadcast-a')
          }
        })
      }
    }

    const get_modal = document.getElementById('exit-modal')

    if (get_modal) {
      this.onShow(get_modal)
      this.mobilePopup(get_modal)
      this.handleManualClose(get_modal)
    }
  }

  handleManualClose(get_modal) {
    document.addEventListener('hidden.bs.modal', (e) => {
      if (e.target === get_modal) {
        console.log('[GlobalPopup] Modal ručno zatvoren, šaljem force_close')
        this.channel.postMessage('popup_force_close')
      }
    })
  }

  closeAllModals() {
    const openModals = document.querySelectorAll('.modal.show')
    openModals.forEach(modal => {
      const modalInstance = Modal.getInstance(modal)
      if (modalInstance) {
        modalInstance.hide()
      }
    })
  }

  onShow(get_modal) {
    const exitModal = new Modal(get_modal)

    if (!('ontouchstart' in window)) {
      window.addEventListener('mouseout', (e) => {
        const homepage_overlay_letters = Boolean(sessionStorage.getItem("seooneclick-scroll-letters-gone"))
        const is_homepage = document.body.classList.contains('home')
        const storedValue = localStorage.getItem('one_click_marketing_exit_modal')
        const currentScroll = window.scrollY || document.documentElement.scrollTop

        const shouldShowPopup = (
          e.relatedTarget === null &&
          e.clientY <= 0 &&
          !storedValue
        )

        if (is_homepage) {
          if (shouldShowPopup && homepage_overlay_letters) {
            this.closeAllModals()
            exitModal.show()
            localStorage.setItem('one_click_marketing_exit_modal', 'closed')
            this.channel.postMessage('popup_closed')
            console.log('[GlobalPopup] Prikazano na homepage (overlay letters)')
          } else if (shouldShowPopup && currentScroll > 0) {
            this.closeAllModals()
            exitModal.show()
            localStorage.setItem('one_click_marketing_exit_modal', 'closed')
            this.channel.postMessage('popup_closed')
            console.log('[GlobalPopup] Prikazano na homepage (scroll)')
          }
        } else if (shouldShowPopup) {
          this.closeAllModals()
          exitModal.show()
          localStorage.setItem('one_click_marketing_exit_modal', 'closed')
          this.channel.postMessage('popup_closed')
          console.log('[GlobalPopup] Prikazano na ostalim stranicama')
        }
      })
    }
  }

  mobilePopup(get_modal) {
    if (window.innerWidth < 1201) {
      let lastScrollTop = 0
      let scrollTimeout
      const exitModal = new Modal(get_modal)

      if ('ontouchstart' in window) {
        window.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout)

          let currentScrollTop = window.scrollY || document.documentElement.scrollTop
          let storedValue = localStorage.getItem('one_click_marketing_exit_modal')

          if (currentScrollTop < lastScrollTop) {
            let scrollDifference = lastScrollTop - currentScrollTop

            if (scrollDifference > 50 && !storedValue) {
              exitModal.show()
              localStorage.setItem('one_click_marketing_exit_modal', 'closed')
              this.channel.postMessage('popup_closed')
              console.log('[GlobalPopup] Prikazano na mobilnom scrollu')
            }
          }

          lastScrollTop = currentScrollTop

          scrollTimeout = setTimeout(() => {
            lastScrollTop = currentScrollTop
          }, 100)
        })
      }
    }
  }
}

export default GlobalPopup
